import { memo } from 'react';

import { useT } from '@/app/i18n/client';
import { Button } from '@/components/ui/button';
import { useCurrency } from '@/features/product/contexts/CurrencyContext';
import type { IProductTotal } from '@/features/product/types/product';
import { utilFromMinorUnit } from '@/lib/utils';

interface IProps {
  totalList?: IProductTotal[];
  totalAmount: number;
  addItemLabel: string;
  addItem: (e: React.MouseEvent<HTMLButtonElement>) => void;
}
function ProductTotal({
  totalList = [],
  totalAmount,
  addItemLabel,
  addItem,
}: Omit<IProps, 'totalAmount'> & { totalAmount: number }) {
  const { t } = useT('product');

  const currency = useCurrency();

  return (
    <div className='border-t border-[#E9ECEF] pt-6 max-sm:flex-col max-sm:items-start max-sm:gap-4'>
      <div className='flex-1'>
        <div className='mb-4 space-y-2 max-sm:space-y-1.5'>
          {totalList.map(
            (price, priceIndex) =>
              price.price > 0 && (
                <div
                  key={price.label}
                  className='flex items-center justify-between text-sm text-[#6C757D] max-sm:text-xs'
                >
                  <span>{price.label}</span>
                  <span>
                    {priceIndex > 0 ? '+' : ''} {currency}{' '}
                    {utilFromMinorUnit(price.price, currency)}
                  </span>
                </div>
              ),
          )}

          <div className='flex items-center justify-between text-sm text-[#6C757D] max-sm:text-xs'>
            <span className='font-bold'>{t('totalAmount')}</span>
            <span className='text-lg font-bold text-[#2E2E2E]'>
              {currency} {utilFromMinorUnit(totalAmount, currency)}
            </span>
          </div>
        </div>
      </div>
      <div className='flex w-full justify-end'>
        <Button
          className='rounded-2xl bg-[#0064FF] px-7 py-6 text-lg font-bold text-white transition-colors duration-300 hover:bg-[#0052CC] max-sm:ml-0 max-sm:w-full max-sm:text-base'
          onClick={addItem}
        >
          {addItemLabel}
        </Button>
      </div>
    </div>
  );
}

export default memo(ProductTotal);
